<!--  -->
<template>
  <div class="twin">
    <div class="tips">典型客户</div>
    <div>众多品牌的一致认可</div>
    <div class="twinMain">
      <div v-for="(item, index) in serviceList" :key="index" class="every">
        <img :src="item.img" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      serviceList: [
        { img: require("@/assets/Frame11712759113.png") },
        { img: require("@/assets/Frame1171275912.png") },
        { img: require("@/assets/Frame1171275913.png") },
        { img: require("@/assets/Frame1171275914.png") },
        { img: require("@/assets/Frame1171275915.png") },
        { img: require("@/assets/Frame1171275916.png") },
        { img: require("@/assets/Frame1171275911.png") },
        { img: require("@/assets/Frame1171275917.png") },
        { img: require("@/assets/Frame1171275918.png") },
        { img: require("@/assets/Frame1171275919.png") },
        { img: require("@/assets/Frame1171275920.png") },
        { img: require("@/assets/Frame1171275921.png") },
        { img: require("@/assets/Frame1171275923.png") },
        { img: require("@/assets/Frame1171275925.png") },
        { img: require("@/assets/Frame1171275926.png") },
        { img: require("@/assets/Frame1171275927.png") },
        { img: require("@/assets/Frame1171275928.png") },
        { img: require("@/assets/Frame1171275929.png") },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.twin {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #141414;
  background: #f4f7fc;
  line-height: 36px;
  padding: 80px 360px;
  .tips {
    font-weight: 500;
    font-size: 28px;
    color: #141414;
    margin-bottom: 5px;
  }
  .twinMain {
    margin-top: 50px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .every {
      // width: 15%;
      margin-bottom: 20px;

      img {
        width: 184px;
        height: 76px;
        margin-right: 10px;
      }
    }
  }
}

/* 在小屏幕上使用单列布局 */
@media (max-width: 768px) {
  .twin {
    padding: 80px 60px;
  }
}
</style>
